import { render, staticRenderFns } from "./MyLeadView.vue?vue&type=template&id=999a24c6&"
import script from "./MyLeadView.vue?vue&type=script&lang=js&"
export * from "./MyLeadView.vue?vue&type=script&lang=js&"
import style0 from "./MyLeadView.vue?vue&type=style&index=0&id=999a24c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports